<template>
  <div class="container">
    <div class="white-frame">
      <div class="title-text mb-3">
        <b>Bens danificados</b>
      </div>
      <div
        class="col-md-12"
        :class="{
          'field-required': validation.objDTO.Veiculo.Obs.$invalid,
        }"
      >
        <label class="form-label" for="bensSinistro">Descrição dos bens:</label>
        <Textarea
          id="bensSinistro"
          v-model="objDTO.Veiculo.Obs"
          :autoResize="true"
          rows="5"
          cols="30"
          :maxlength="1000"
          class="form-control"
        />
      </div>
      <div class="col-md-6" v-if="showEstimativaPrejuizo">
        <!--Estimativa de Prejuízo (facultativo).  -->
        <label for="estimativaPrejuizoBensDanificados" class="form-label"
          >Estimativa de Prejuízo</label
        >
        <InputNumber
          id="estimativaPrejuizoBensDanificados"
          v-model="objDTO.Veiculo.ValorEstimadoReparacao"
          :minFractionDigits="2"
          :maxFractionDigits="2"
          mode="currency"
          currency="BRL"
          class="form-control p-0"
          locale="pt-BR"
        />
      </div>
    </div>
  </div>
  <!-- Descrição dos bens (obrigatório); -->
  <!-- Estimativa do Prejuízo -->
</template>

<script>
import { mapGetters } from 'vuex';

export default {
  props: {
    validation: {
      type: Object,
      required: true,
    },
    showEstimativaPrejuizo: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    ...mapGetters({ objDTO: 'getObjDTO' }),
  },
  created() {
    // Garante que o campo ValorEstimadoReparacao esteja inicializado
    if (this.objDTO && this.objDTO.Veiculo && this.objDTO.Veiculo.ValorEstimadoReparacao === undefined) {
      this.objDTO.Veiculo.ValorEstimadoReparacao = 0;
    }
  }
};
</script>

<style></style>
